'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularMaterial = require('angular-material');

var _angularMaterial2 = _interopRequireDefault(_angularMaterial);

var _angularMessages = require('angular-messages');

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _jsonForm = require('../components/json-form.directive');

var _jsonForm2 = _interopRequireDefault(_jsonForm);

var _jsonform = require('./jsonform.routes');

var _jsonform2 = _interopRequireDefault(_jsonform);

var _jsonform3 = require('./jsonform.controller');

var _jsonform4 = _interopRequireDefault(_jsonform3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.jsonform', [_angularUiRouter2.default, _angularMaterial2.default, _angularMessages2.default, _jsonForm2.default]).config(_jsonform2.default).controller('JsonFormController', _jsonform4.default).name;


// WEBPACK FOOTER //
// ./src/app/jsonform/index.js